const radio = require('lib/radio')

function triggerError(err) {
    radio.editpanel.trigger('error', err)
}

module.exports = triggerError
